export const MANAGERS = [
  {
    key: "SanjayRewani1619",
    name: "Sanjay",
    target: 1100,
    photo: "/managers/sanjayrewani.jpeg",
  },
  {
    key: "JayVijay5099",
    name: "Jay",
    target: 800,
    photo: "/managers/jay.jpeg",
  },
  {
    key: "Himanshu1203",
    name: "Himanshu",
    target: 400,
    photo: "/managers/himanshu.png",
  },
  {
    key: "LavitBhati714",
    name: "Lavit Bhati",
    target: 400,
    photo: "/managers/lavit.jpeg",
  },
  // {
  //   key: "Amit Singh 6201",
  //   name: "Amit Singh",
  //   target: 350,
  //   photo: "/managers/amitsingh.jpeg",
  // },
  {
    key: "AmitSingh6201",
    name: "Amit Singh",
    target: 400,
    photo: "/managers/amitsingh.jpeg",
  },
];

export const FLOOR_HEADS = [
  {
    key: "GMIT",
    name: "Rahul Bhusan",
    target: 1050,
    photo: "/managers/rahulbhusan.jpeg",
  },
  {
    key: "ALTF",
    name: "Anand Suman",
    target: 2100,
    photo: "/managers/anandsuman.png",
  },
];

export const FLOOR_MANAGERS = {
  GMIT: ["JayVijay5099", "LavitBhati714", "Nitin5210"],
  ALTF: [
    "SanjayRewani1619",
    // "Anand Suman 254",
    "Himanshu1203",
    // "Prashant5534",
    // "Sharvan242",
    "Amit Singh 6201",
    "AmitSingh6201",
    "Customer Support"
  ],
};


export const MANAGER_META = {
  SanjayRewani1619: {
    name: "Sanjay",
    target: 1100,
    photo: "/managers/sanjayrewani.jpeg",
  },
  Himanshu1203: {
    name: "Himanshu",
    target: 400,
    photo: "/managers/himanshu.png",
  },
  LavitBhati714: { name: "Lavit", target: 400, photo: "/managers/lavit.jpeg" },
  JayVijay5099: { name: "JayVijay", target: 800, photo: "/managers/jay.jpeg" },
  // "Amit Singh 6201": { name: "Amit Singh", target: 350, photo: "/managers/amitsingh.jpeg" },
  AmitSingh6201: { name: "Amit Singh", target: 400, photo: "/managers/amitsingh.jpeg" },
};
